// extracted by mini-css-extract-plugin
export default {"cancelLabel":"styles_cancelLabel__feWy8","submitWrapper":"styles_submitWrapper__qU9P0"};